import { render, staticRenderFns } from "./Magytrack.vue?vue&type=template&id=88ac2f4c&"
import script from "./Magytrack.vue?vue&type=script&lang=js&"
export * from "./Magytrack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports